import { render, staticRenderFns } from "./serviceOverview.vue?vue&type=template&id=a41453d8&scoped=true"
import script from "./serviceOverview.vue?vue&type=script&lang=js"
export * from "./serviceOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41453d8",
  null
  
)

export default component.exports